import { render } from "./CommunityCard.vue?vue&type=template&id=e40f0cf6"
import script from "./CommunityCard.vue?vue&type=script&lang=js"
export * from "./CommunityCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__